import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchMePersonally = createAsyncThunk("fetchMePersonally", async () => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`analytics/summary?myLeaderShip=false`, config);

	return response.data;
});

const mePersonallySlice = createSlice({
	name: "mePersonallySlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetMePersonallyState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMePersonally.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMePersonally.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchMePersonally.rejected, (state, action) => {
			state.isLoading = false;
			state.data = null;
			state.error = action.payload;
		});
	},
});

export const { resetMePersonallyState } = mePersonallySlice.actions;
export default mePersonallySlice.reducer;
